<h2 mat-dialog-title>Detalle de Movimientos de Cuentas Deudoras</h2>

<div mat-dialog-content>

  <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

    <div fxFlex=40 fxFlex.xs=100 class="flex-item">
      <mat-expansion-panel [expanded]="true" hideToggle="true">
        <div fxLayout="row stretch" fxLayout.xs="column">
          <mat-label><b>Concepto</b>: {{input?.SelectedRow?.Concepto}}</mat-label>
        </div>
      </mat-expansion-panel>
    </div>
    <div fxFlex=30 fxFlex.xs=100 class="flex-item">
      <mat-expansion-panel [expanded]="true" hideToggle="true">
        <div fxLayout="row stretch" fxLayout.xs="column">
          <mat-label>
            <b>Saldo</b>: {{input?.SelectedRow?.Moneda}} {{input?.SelectedRow?.Saldo | number:'1.2-2'}}
          </mat-label>
        </div>
      </mat-expansion-panel>
    </div>
    <div fxFlex=30 fxFlex.xs=100 class="flex-item">
      <mat-expansion-panel [expanded]="true" hideToggle="true">
        <div fxLayout="row stretch" fxLayout.xs="column">
          <mat-label>
            <b>Saldo Vencido</b>: {{input?.SelectedRow?.Moneda}} {{input?.SelectedRow?.SaldoVencido | number:'1.2-2'}}
          </mat-label>
        </div>
      </mat-expansion-panel>
    </div>

  </div>

  <mat-expansion-panel [expanded]="true" *ngIf="!input.VerSoloContactos">

    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon style="margin-top: -3px;">attach_money</mat-icon> Detalle de Movimientos
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;" *ngIf="isSearching">
      <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    </div>

    <ng-container *ngIf="!isSearching">

      <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" style="margin-top: 10px;">

        <div fxFlex=100 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true">
            <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 15px;">
              <mat-checkbox [(ngModel)]="verSoloVencidos" (change)="onVerSoloVencidosChange()">Ver solo movimientos vencidos al {{input?.FechaVencimientoControl | date:'dd/MM/yyyy'}}</mat-checkbox>
            </div>
          </mat-expansion-panel>
        </div>

      </div>

      <div fxLayout="row stretch" fxLayout.xs="column">

        <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' 
          [pageSettings]='pageSettings' [allowResizing]='true'>
          <e-columns>
            <e-column field='FechaMovimiento' headerText='Fecha' width=90 type='date'>
              <ng-template #template let-data>
                {{data.FechaMovimiento | date:'dd/MM/yyyy HH:mm:ss'}}
              </ng-template>
            </e-column>
            <e-column field='FechaVencimiento' headerText='Vencimiento' width=90 type='date'>
              <ng-template #template let-data>
                {{data.FechaVencimiento | date:'dd/MM/yyyy'}}
              </ng-template>
            </e-column>
            <e-column field='CuentaImputada' headerText='Referencia' width=90></e-column>
            <e-column field='TipoMovimientoNombre' headerText='Tipo' width=80></e-column>
            <e-column field='Detalle' headerText='Detalle' width=100></e-column>
            <e-column field='Monto' headerText='Monto' textAlign="right" width=70>
              <ng-template #template let-data>
                {{data.Moneda}} {{data.Monto | number:'1.2-2'}}
              </ng-template>
            </e-column>
            <!-- <e-column field='AlicuotaIvaNombre' headerText='IVA' width=50></e-column> -->
            <e-column field='Saldo' headerText='Saldo' textAlign="right" width=70>
              <ng-template #template let-data>
                {{data.Moneda}} {{data.Saldo | number:'1.2-2'}}
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>

      </div>

    </ng-container>

  </mat-expansion-panel>

  <ng-container *ngIf="contactosList != null && contactosList.length > 0">

    <br/>

    <mat-expansion-panel [expanded]="(input.VerSoloContactos == true)">

      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon style="margin-top: -3px;">supervisor_account</mat-icon> Datos de Contactos
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div fxLayout="row stretch" fxLayout.xs="column">

        <ejs-grid #contactosGrid [dataSource]='contactosList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
          [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
          <e-columns>
            <e-column field='Nombre' headerText='Nombre' textAlign="center" width=90></e-column>
            <e-column field='MailContacto' headerText='Mail' textAlign="center" width=80></e-column>
            <e-column field='MovilContacto' headerText='Móvil' textAlign="center" width=70></e-column>
            <e-column field='Detalle' headerText='Detalle' textAlign="center" width=100></e-column>
            <e-column headerText='Acciones' width=70>
              <ng-template #template let-data>
                <a style="cursor: pointer; margin-right: 5px;" (click)="enviarDetalleDeuda(data, 'MAIL')" *ngIf="data.MailContacto != null && data.MailContacto.length > 0" 
                  title="Enviar detalle de deuda al mail del contacto">
                  <i class="fa fa-envelope fa-1x"></i>
                </a>
                <a style="cursor: pointer; margin-right: 5px;" (click)="enviarDetalleDeuda(data, 'WHATSAPP')" *ngIf="data.MovilContacto != null && data.MovilContacto.length > 0" 
                  title="Enviar detalle de deuda al WhatsApp del contacto">
                  <i class="fab fa-whatsapp fa-lg"></i>
                </a>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>

      </div>

    </mat-expansion-panel>

  </ng-container>

</div>

<br/>

<div mat-dialog-actions>
  <div fxLayout="row stretch" fxLayout.xs="column">
    <button mat-raised-button color="warn" (click)="onAccept()" class="zb-button">Cerrar</button>
    <ng-container *ngIf="!input.VerSoloContactos">
      <button mat-raised-button (click)="onExport()" [disabled]="isExporting || isContactosExporting" color="primary" class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar Detalle Movimientos'}}</button>
      <button mat-raised-button (click)="onExportContactos()" [disabled]="isExporting || isContactosExporting" *ngIf="contactosList != null && contactosList.length > 0" class="zb-button">{{isContactosExporting ? 'Exportando...' : 'Exportar Movimientos + Contactos'}}</button>
    </ng-container>
  </div>
</div>